import { render, staticRenderFns } from "./LoadFromEconomicRegistry.vue?vue&type=template&id=229a9966"
import script from "./LoadFromEconomicRegistry.vue?vue&type=script&lang=js"
export * from "./LoadFromEconomicRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports